import ApiService from '@/core/services/api.service';
import { STOCK_TRANSFER_TYPE } from '@/utils/enum';

// t103002: phiếu chuyển máy tồn kho thu cũ, có hoặc không tick "Được bán"
export const isTradeInTransferType = (stockTransferType) =>
  [STOCK_TRANSFER_TYPE.TRADE_IN, STOCK_TRANSFER_TYPE.TRADE_IN_SALEABLE].includes(
    Number(stockTransferType),
  );

// IMEI của 1 dòng chuyển kho (ô IMEI nhập nhiều máy, cách nhau bằng xuống dòng hoặc dấu phẩy)
export const splitLineImeis = (imeiText) =>
  String(imeiText || '')
    .split(/[\n\r,]/)
    .map((imei) => imei.trim())
    .filter(Boolean);

// Hỏi BE IMEI nào đang ở tồn kho thu cũ tại cửa hàng - BE là nguồn duy nhất, dùng được cho mọi cách
// thêm dòng (chọn gợi ý, gõ tay, nhập Excel, sửa ô IMEI)
export const fetchTradeInImeis = async (storeId, imeis) => {
  if (!storeId || !imeis.length) return [];
  const { data } = await ApiService.query('stocks/trade-in-imeis', {
    params: { storeId, imeis: imeis.join(',') },
  });
  return data.data || [];
};
